/*
  global AdobeAnalyticsRSID, SalesforceMobileLinksRedirect, FavoritesEnabled, RefreshWhenNoAuth, DefaultBreakpoint, NetworkConfig, FooterUpsellEnabled, HeapKey, EnableXidIntegration, pSUPERFLY
*/
import React, { Component } from 'react';
import 'intersection-observer'; // IE11 polyfill
import 'helpers/uspapi';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import WindowResizeListener from 'react-window-size-listener';
import _ from 'lodash';
import { Events as scrollEvents, animateScroll } from 'react-scroll';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import StickyBanner from 'components/StickyBanner';
import { getFontHelmetTag } from 'helpers/HelmetHelper';
import Seo from 'componentsV2/Seo';
import ContinueWatchingCTA from 'componentsV2/ContinueWatchingCTA';
import { noop } from 'helpers/GlobalHelper';
import getOpeFoxSdk from 'helpers/ScriptHelper';
import { findProvider, getProviderObjectFromList } from 'helpers/AuthHelper';
import { setFoxNewsCookie, MVPD_COOKIE_NAME as mvpdCookieName } from 'index/AuthHelper';
import {
  getAccount,
  getAnonymousAccount,
  toggleAccountExpired,
  anonymousLogin as helperAnonymousLogin,
} from 'helpers/Account';
import {
  cookieFactory,
  getCookie,
  getDomain,
  getLocalStorageItem,
  getSessionStorageItem,
  removeCookie,
  removeLocalStorageItem,
  setCookie,
  setLocalStorageItem,
  setSessionStorageItem,
} from 'helpers/Storage';
import PubSub from 'helpers/PubSub';
import {
  getFontClassName,
  getMVPDFromCookie,
  getNetworkLogoUrl,
  getPrivacyParameterCookie,
  getPurchaseSourceCookie,
  getStickBannerData,
  getUrlParameter,
  isLive,
  isMvpdSubscription,
  isNationLicensed,
  isStaticRender,
  isTypeVideo,
  isUpcomingContent,
  sportsFeatures,
} from 'helpers/ContentHelper';
import { getFavoritesFromStorage, getUserTraits } from 'helpers/AccountHelper';
import {
  appDownloadPromptEnabled,
  getBlackoutConfig,
  isNationEntitled,
  nationDigitalChannelEnabled,
  previewPassEnabled,
  seriesAnonymousEnabled,
  setDebugFromUrl,
  setOptOutCCPACookie,
  tveEnabled,
} from 'helpers/ConfigHelper';
import { isValidPage } from 'helpers/PageHelper';
import {
  getCampaignOverrides,
  helperGetHomeUrl,
  isAppView,
  isAppViewExcluded,
  isGeoLocationBlocked,
  isMaintenance,
  redirectSalesForceLinksiOS,
  redirectUserOnReEntry,
} from 'helpers/RouteHelper';
import { isTestEnvironment } from 'helpers/TestHelper';
import { OVERLAY_BREAKPOINTS, OVERLAY_HEADER_SEARCH } from 'helpers/FilterHelper';
import {
  DEBOUNCE_TIME,
  getSitePlatform,
  isMobileBreakpoint,
  isTabletBreakpoint,
  SITE_PLATFORM_MOBILE,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_WEB_LARGE,
  SITE_PLATFORM_WEB,
} from 'helpers/BreakpointHelper';
import { getStoredAuthenticatedMVPD } from 'helpers/AuthClientlessHelper';
import { resetAnonymous } from 'helpers/AnonymousHelper';
import {
  callTealiumPageView,
  mountDataLayer,
  PageNames,
  resetPageReferrerData,
  setBlockReferrerAnalyticsTracking,
  setSegmentLoaded,
  sortEntitlements,
  trackPageReferrerAnalytics,
} from '@foxcorp/delta-web-analytics';
import { logEvent } from 'helpers/LogReportHelpers';
import { getCachedLocation } from 'helpers/GeoLocationHelper';
import initializeRedfast from 'helpers/RedfastHelper';
import initializeDataDog from 'helpers/DataDogHelpers';
import { setInitOptimizelyAttributes, getOptimizely } from 'helpers/OptimizelyHelper';
import {
  addBodyClass,
  removeBodyClass,
  addHTMLClass,
  removeHTMLClass,
  getTheme,
  webThemeIds,
  wrapComponentsWithThemeProvider,
} from 'helpers/ThemeHelper';
import reset from 'themes/_reset.css'; // eslint-disable-line
import AuthContainer from 'components/AuthContainer';
import Header from 'components/Header';
import Footer from 'components/Footer';
import FooterUpsell from 'components/FooterUpsell';
import Segment from 'components/Segment';
import VideoPlayerGlobal from 'components/VideoPlayerGlobal';
import CanIAutoplay from 'components/CanIAutoplay';
import withErrorBoundary from 'components/withErrorBoundary';
import { isPreviewPass } from 'helpers/PlayerHelper';
import BlackoutDefinitionFetcher from 'components/BlackoutDefinitionFetcher';
import { smartBannerPresent } from 'components/Header/HeaderHelpers';
import FreemiumModalContainer from 'components/FreemiumModalContainer';
import { makeSelectSeriesDetailSeriesData } from 'screens/ContentDetail/selectors';
import {
  getTabName,
  PROMO_TYPE_INSET,
  PROMO_TYPE_LEAD,
  PROMO_TYPE_MARKETING_VIDEO,
} from 'helpers/SeriesDetailHelpers';
import { makeSelectGlobalVideoPanelVideo } from 'screens/Watch/selectors';
import { initBraze, LogBrazePathChange } from 'helpers/Braze';
import { clearSeriesDetail } from 'screens/ContentDetail/ContentDetailActions';
import {
  clearContinueWatchingCTA,
  fetchCurrentActivePlans,
  fetchContinueWatchingAction,
  fetchMVPDProvidersAction,
  fetchUserSubscriptionStatusAction,
  setFreemiumModalVisibilityAction,
  setPreauthorizedResourcesAction,
  setRecommendationIdAction,
  setUserAuthData,
} from './AppActions';
import {
  getFavorites,
  getFavoritesDetails,
  deleteFavorites,
  setFavorites,
  setAppFavorites,
} from './AppFavoritesHelpers';
import FreemiumProvider, { FreemiumContext } from './FreemiumProvider';

import AppStyleModule from './App.module.scss';

import {
  injectKruxTag,
  timedOutInit as timedOutInitSegment,
  timedOutLoadScripts,
} from '../external-scripts';

const style = getTheme(webThemeIds.App);

const breakpoints = {
  [SITE_PLATFORM_WEB_LARGE]: {
    autoFocus: true,
    mainBackground: null,
    breakpointDisableScroll: false,
  },
  [SITE_PLATFORM_WEB]: {
    autoFocus: true,
    mainBackground: null,
    breakpointDisableScroll: false,
  },
  [SITE_PLATFORM_TABLET]: {
    autoFocus: false,
    mainBackground: null,
    breakpointDisableScroll: true,
  },
  [SITE_PLATFORM_MOBILE]: {
    autoFocus: false,
    mainBackground: null,
    breakpointDisableScroll: true,
  },
};

const LAST_SESSION_PATH = 'lastFoxPath';
const APP_CLOSED = 'APP_CLOSED';

function loadExternalLibs() {
  timedOutInitSegment();
  timedOutLoadScripts();

  const unsubscribePageLoaded = PubSub.subscribe('PAGE_LOADED', () => {
    unsubscribePageLoaded();
    injectKruxTag();
  });
}

class App extends Component {
  constructor(props) {
    super(props);
    setSegmentLoaded();
    this.mapAnalytics();
    initializeDataDog();
    initializeRedfast();
    window.AdobeAnalyticsRSID = AdobeAnalyticsRSID;
    const { branding } = NetworkConfig;
    let breakpoint = SITE_PLATFORM_WEB;
    const locationCookies = getCachedLocation({ cb: this.locationCallback });

    if (typeof DefaultBreakpoint !== 'undefined') {
      breakpoint = DefaultBreakpoint || breakpoint;
    } else if (!isStaticRender()) {
      breakpoint = getSitePlatform();
    }

    this.state = {
      accountExpired: false,
      adblock: false,
      apiBreakpoint: null,
      authCheckComplete: false,
      authSuccess: false,
      blackoutDefinitions: null,
      blockReferrerAnalyticsTracking: false,
      blockSuccessScreen: false,
      breakpoint,
      campaignOverrides: getCampaignOverrides(),
      coordinates: locationCookies,
      currentPage: null,
      favorites: null,
      favoritesDetails: null,
      firstCollectionImpression: false,
      firstIdentifyCall: false,
      isHeader: null,
      isHeaderPinned: true,
      isHomePage: false,
      isListPage: false,
      isLivePage: false,
      isLoadingFavorites: false,
      isNationDigitalChannelEnabled: nationDigitalChannelEnabled(),
      isNavScheduleRendered: false,
      isPageLoading: false,
      isPlayerLoaded: null,
      isSmartBannerEnabled: true,
      isVideoHero: null,
      isWatchPage: false,
      mvpdAuthOverlayProps: {},
      mvpdSignInTrigger: false,
      network: [branding],
      overlay: null,
      preauthRefreshComplete: false,
      provider: null,
      renderMvpdAuthOverlay: false,
      renderLoader: false,
      triggerAuthCheck: false,
      upcomingOverlayOpen: false,
      useUtagGlobal: true,
    };

    this.setBlockReferrerAnalyticsTracking = setBlockReferrerAnalyticsTracking.bind(this);
    this.trackPageReferrerAnalytics = trackPageReferrerAnalytics.bind(this);
    this.setMVPDSignInTrigger = newValue => {
      this.setState({
        mvpdSignInTrigger: newValue,
        renderMvpdAuthOverlay: newValue,
      });
    };
    this.setTriggerAuthCheck = newValue => {
      this.setState({
        triggerAuthCheck: newValue,
      });
    };
    this.onAuthCheckComplete = ({ complete, success, cb }) => {
      const nextState = {};
      if (complete !== undefined) nextState.authCheckComplete = complete;
      if (success !== undefined) nextState.authSuccess = success;
      const callback = cb || _.noop;
      this.setState(nextState, callback);
    };
    this.resetAnonymous = resetAnonymous.bind(this);
    this.onBlackoutDefinitionFetcherUpdate = blackoutDefinitions =>
      // TODO: we might be able to use redux for this state.blackoutDefinitionFetcher.definition
      this.setState({
        blackoutDefinitions,
      });
    this.firstSegmentIdentifyCalled = () => this.setState({ firstIdentifyCall: true });
    this.collectionImpressionCalled = () => this.setState({ firstCollectionImpression: true });
    this.upcomingOverlayOpen = state => {
      if (!state) {
        this.disableScrollByClass({ disableScroll: false, bodyOnly: true });
      } else {
        this.disableScrollByClass({ disableScroll: true, bodyOnly: true });
      }
      this.setState({ upcomingOverlayOpen: state });
    };

    window.PreviewPassEnabled = previewPassEnabled();
    window.RefreshWhenNoAuth = RefreshWhenNoAuth;

    if (FavoritesEnabled) {
      this.setAppFavorites = setAppFavorites.bind(this);
      this.getFavorites = getFavorites.bind(this);
      this.getFavoritesDetails = getFavoritesDetails.bind(this);
      this.setFavorites = setFavorites.bind(this);
      this.deleteFavorites = deleteFavorites.bind(this);
    } else {
      this.setAppFavorites = () => {};
      this.getFavorites = () => {};
      this.getFavoritesDetails = () => {};
      this.setFavorites = () => {};
      this.deleteFavorites = () => {};
    }
  }

  async componentDidMount() {
    const { breakpoint } = this.state;
    const {
      account,
      anonymousAccount,
      anonymousId,
      deviceId,
      fetchCurrentActivePlans,
      fetchUserSubscriptionStatus,
      isAuthenticated,
      location,
      profile,
    } = this.props;
    const { pathname, search } = location;
    this.getFavorites();
    const profileId = account?.profileId || anonymousAccount?.profileId;
    if (EnableXidIntegration) {
      browserHistory.listen(() => {
        profile.getXid({ baseUrl: window.location?.origin }).then(xidResponse => {
          const xid = xidResponse?.xid;
          profile.submitXidEvent({ eventType: 'view', originBu: 'foxnation', xid });
        });
      });
    }
    const isBrowserLink = pathname?.includes('/u/');
    if (isBrowserLink) {
      const newPath = pathname.replace('/u/', '/');
      window.history.pushState('', '', newPath + search);
    }
    const isLandedNationDigital = nationDigitalChannelEnabled() && pathname?.includes('live-news');
    setOptOutCCPACookie();
    const script = document.createElement('script');
    if (getPrivacyParameterCookie()) {
      const {
        lastAnonymousProfileId = '',
        isSignedIntoProfile,
        lastKnownProfileID = '',
      } = getUserTraits();
      script.innerHTML = getOpeFoxSdk({
        profileId,
        anonymousId,
        lastAnonymousProfileId,
        isSignedIntoProfile,
        lastKnownProfileID,
      });
    }
    document.head.appendChild(script);
    setFoxNewsCookie(account || anonymousAccount);
    if (account) {
      const { accessToken } = account;
      fetchUserSubscriptionStatus(accessToken);
    }
    if (!isNationEntitled()) {
      fetchCurrentActivePlans({ accessToken: account?.accessToken, deviceId });
    }
    logEvent('onAppLoad');
    const heap = window?.heap;
    let xidResponse;
    if (EnableXidIntegration) {
      try {
        xidResponse = await profile.getXid({ baseUrl: window.location?.origin });
      } catch (error) {
        console.log('getXid Request failed', error);
      }
    }
    const localXID = getLocalStorageItem({ key: 'xid' });
    const xid = EnableXidIntegration ? xidResponse?.xid : localXID;
    if (EnableXidIntegration) {
      profile.submitXidEvent({ eventType: 'view', originBu: 'foxnation', xid });
      const Fennec = window.Fennec || null;
      if (Fennec) {
        window.fennecInstance = new Fennec('nation');
        window.fennecInstance?.initFennec();
      }
    }
    if (xid && HeapKey && heap) {
      heap.load(HeapKey, {
        rewrite: heapProps => {
          if (heapProps.event_properties) {
            if (!heapProps.event_properties.custom) {
              // eslint-disable-next-line no-param-reassign
              heapProps.event_properties.custom = {};
            }
            // eslint-disable-next-line react/prop-types, no-param-reassign
            heapProps.event_properties.custom = Object.assign(
              {},
              heapProps.event_properties.custom,
              {
                original_user_id: heap.userId,
              },
            );
          }
          return heapProps;
        },
      });
    }
    window.onstorage = e => {
      if (e.key === APP_CLOSED) {
        removeLocalStorageItem({ key: APP_CLOSED });
      }
    };
    if (window.name === 'mvpd-success-window') {
      window.close();
    }
    if (isMvpdSubscription()) {
      window.addEventListener('beforeunload', () =>
        setLocalStorageItem({ key: APP_CLOSED, value: Date.now() }),
      );
    }
    resetPageReferrerData();
    this.trackPageReferrerAnalytics({ name: PageNames.DEEPLINK });
    setSessionStorageItem({ key: LAST_SESSION_PATH, value: '' });
    if (SalesforceMobileLinksRedirect) redirectSalesForceLinksiOS();
    setInitOptimizelyAttributes(isAuthenticated, account);
    if (!smartBannerPresent(breakpoint)) {
      this.setSmartBannerEnabled(false);
    }
    const hash = _.get(this.props, 'location.hash');
    if (hash) setDebugFromUrl(hash);
    redirectUserOnReEntry();
    if (isLandedNationDigital) this.setDisableScroll({ disableScroll: true });

    this.setState({ renderLoader: false });
    loadExternalLibs();
    initBraze();
    LogBrazePathChange(pathname);
  }

  // eslint-disable-next-line no-unused-react-component-methods/no-unused-react-component-methods
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { favoriteDetails, favorites } = this.state;
    const nextPathName = _.get(nextProps, 'location.pathname');
    const isAccountPage = /^\/(tv\/)*account((\/\w+)+|\/?)$/.test(nextPathName);
    if (isAccountPage && (!favorites || (favorites && !favoriteDetails))) {
      this.getFavoritesDetails();
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    const hash = _.get(this.props, 'location.hash');
    const prevHash = _.get(prevProps, 'location.hash');
    const { breakpoint, overlay } = this.state;
    const { breakpoint: prevBreakpoint, overlay: prevOverlay } = prevState;
    const {
      account,
      anonymousAccount,
      bookmarks,
      clearSeriesDetail,
      fetchContinueWatchingAction,
      location,
      setUserAuthData,
      showMobileRoadblock,
      stickyBanner,
    } = this.props;

    const {
      account: prevAccount,
      anonymousAccount: prevAnonymousAccount,
      bookmarks: prevBookmarks,
      location: prevLocation,
      showMobileRoadblock: prevShowMobileRoadblock,
      stickyBanner: prevStickyBanner,
    } = prevProps;

    const currentPath = location?.pathname;
    const isWatchPage = currentPath.includes('/watch');
    const isLivePage = currentPath.includes('/live-news');
    const prevPath = prevLocation?.pathname;
    const pathChanged = currentPath !== prevPath;
    const isLandedNationDigital =
      nationDigitalChannelEnabled() &&
      (pathChanged || breakpoint !== prevBreakpoint || overlay !== prevOverlay) &&
      currentPath?.includes('live-news');
    const isLeavingNationDigital =
      nationDigitalChannelEnabled() && pathChanged && prevPath?.includes('live-news');
    const accountAdded = !prevAccount && account;
    const accountChanged = account && account !== prevAccount;
    const anonymousAccountChanged = anonymousAccount && anonymousAccount !== prevAnonymousAccount;
    const showMobileRoadblockChanged = prevShowMobileRoadblock && !showMobileRoadblock;
    const isAnonymousAccountLogin = anonymousAccountChanged && !anonymousAccount.isNew;
    const isSearchOverlay = overlay === OVERLAY_HEADER_SEARCH;
    const overlayChanged = prevOverlay !== overlay;
    const bookmarksChanged = prevBookmarks !== bookmarks;
    if (overlayChanged) this.setBlockReferrerAnalyticsTracking(isSearchOverlay || false);
    if (accountAdded) setUserAuthData({ anonymousAccount: null });
    if (isLandedNationDigital) this.setDisableScroll({ disableScroll: true });
    if (isLeavingNationDigital) this.setDisableScroll({ disableScroll: false });
    if (showMobileRoadblockChanged) clearSeriesDetail();
    if (bookmarks && bookmarksChanged && !isWatchPage && !isLivePage && isNationEntitled()) {
      const latestBookmark = bookmarks?.list?.[0];
      const id = latestBookmark?.['@id']?.split('/').slice(-1)[0];
      if (id) {
        fetchContinueWatchingAction({
          id,
          accessToken: account?.accessToken,
          deviceId: account?.deviceId,
        });
      }
    }

    if (accountChanged || isAnonymousAccountLogin) this.getFavorites();

    const hashChanged = hash && hash !== prevHash;
    if (hashChanged) setDebugFromUrl(hash);

    if (!prevStickyBanner && stickyBanner) {
      this.setState({ stickyBanner });
    }
    if (pathChanged) {
      LogBrazePathChange(currentPath);
    }
    if (pathChanged && currentPath !== '/browse/') {
      setTimeout(() => {
        pSUPERFLY.virtualPage({
          sections: '',
          authors: '',
          path: `${currentPath}`,
          title: document.title,
        });
      }, 3000);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('unload', () => {});
  }

  mapAnalytics = () => {
    const { anonymousAccount } = this.props;

    window.DataLayer = mountDataLayer({
      cookieFactory,
      enums: {
        MVPD_COOKIE: mvpdCookieName,
        PROMO_TYPE_INSET,
        PROMO_TYPE_LEAD,
        PROMO_TYPE_MARKETING_VIDEO,
      },
      getAccount: () => getAccount(!!anonymousAccount),
      getAnonymousAccount: () => getAnonymousAccount(),
      getCookie,
      getDetailTabName: getTabName,
      getFavorites: getFavoritesFromStorage,
      getLocalStorage: getLocalStorageItem,
      getMVPD: getMVPDFromCookie,
      getOptimizely,
      getPurchaseSource: getPurchaseSourceCookie,
      getQueryParameter: getUrlParameter,
      getSessionStorage: getSessionStorageItem,
      getSportsFeatures: sportsFeatures,
      isContentLive: isLive,
      isNation: () => true,
      isNationNewsEnabled: () => true,
      isPreviewPass,
      isTestEnvironment,
      isTveEnabled: tveEnabled,
      isUpcomingContent,
      isVideoTile: isTypeVideo,
      removeCookie,
      setCookie,
      setLocalStorage: setLocalStorageItem,
      setSessionStorage: setSessionStorageItem,
    });
  };

  onWindowResize = _.debounce(() => {
    const windowWidth = _.get(window, 'innerWidth');
    const {
      breakpoint: currentBreakpoint,
      apiBreakpoint: currentApiBreakpoint,
      overlay,
      useSimplified,
    } = this.state;
    const newBreakpoint = getSitePlatform(windowWidth);
    const newApiBreakpoint = !isStaticRender() ? newBreakpoint : currentApiBreakpoint;
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    const newState = {};
    if (newBreakpoint !== currentBreakpoint) {
      newState.breakpoint = newBreakpoint;
      let disableScroll = false;
      if (overlay) {
        disableScroll = OVERLAY_BREAKPOINTS[newBreakpoint].indexOf(overlay) >= 0;
      }
      if (useSimplified) {
        disableScroll = true;
      }
      this.setDisableScroll({ disableScroll });
    }
    if (newApiBreakpoint !== currentApiBreakpoint) {
      newState.apiBreakpoint = newBreakpoint;
    }
    if (newState.breakpoint || newState.apiBreakpoint) {
      this.setState(newState);
    }
  }, DEBOUNCE_TIME);

  getCurrentPage = () => {
    const { currentPage } = this.state;
    return currentPage;
  };

  getExternalHelpers() {
    const {
      authCheckComplete,
      authSuccess,
      blockReferrerAnalyticsTracking,
      favorites,
      favoritesDetails,
      isLoadingFavorites,
      renderMvpdAuthOverlay,
    } = this.state;

    const {
      account,
      anonymousAccount,
      anonymousId,
      authorizationToken: accessToken,
      deviceId,
      preauthorizedResources,
      profileFavorites,
      profileBookmarks,
      mvpd,
      recommendationId,
      routes,
      segmentDeviceId,
    } = this.props;
    const profileId = account?.profileId || anonymousAccount?.profileId;
    const appView = isAppView(routes);
    const geoLocationBlocked = isGeoLocationBlocked(routes);
    const maintenance = isMaintenance(routes);

    return {
      authCheckComplete,
      authSuccess,
      setProvider: this.setProvider,
      toggleAccountExpired: toggleAccountExpired.bind(this),
      favoritesManager: {
        deleteFavorites: this.deleteFavorites,
        favorites: favorites || [],
        favoritesDetails: favoritesDetails || [],
        isLoadingFavorites,
        setFavorites: this.setFavorites,
      },
      setOverlay: this.setOverlay,
      setVideoHero: () => {
        this.setState({ isVideoHero: true });
      },
      removeVideoHero: () => {
        this.setState({ isVideoHero: false });
      },
      onAuthCheckComplete: this.onAuthCheckComplete,
      renderAuthContainer: this.renderAuthContainer,
      renderMvpdAuthOverlay,
      setBlockMVPDIncomplete: this.setBlockMVPDIncomplete,
      setCoordinates: this.setCoordinates,
      setAuthorizationToken: this.setAuthorizationToken,
      setCurrentPage: this.setCurrentPage,
      getCurrentPage: this.getCurrentPage,
      setWatchPage: this.setWatchPage,
      setLivePage: this.setLivePage,
      setListPage: this.setListPage,
      setHomePage: this.setHomePage,
      setLoading: this.setLoading,
      setIsPlayerLoaded: this.setIsPlayerLoaded,
      setMVPDToAppState: this.setMVPDToAppState,
      setTriggerAuthCheck: this.setTriggerAuthCheck,
      toggleMvpdAuthOverlay: this.toggleMvpdAuthOverlay,
      pageViewEvent: this.pageViewEvent,
      setIsAuthenticated: this.setIsAuthenticated,
      appView,
      mvpdData: mvpd,
      isAppViewExcluded,
      geoLocationBlocked,
      maintenance,
      getUseUtagGlobal: () => {
        const { useUtagGlobal } = this.state;
        if (useUtagGlobal) this.setState({ useUtagGlobal: false });
        return useUtagGlobal;
      },
      blockReferrerAnalyticsTracking,
      anonymousId,
      anonymousAccount,
      preauthorizedResources,
      accessToken,
      profileId,
      profileBookmarks,
      profileFavorites,
      anonymousLogin: this.anonymousLogin,
      recommendationId,
      deviceId,
      segmentDeviceId,
    };
  }

  locationCallback = (error, coordinates) => {
    if (error) this.setCoordinates(null);
    if (coordinates) this.setCoordinates(coordinates);
  };

  setAuthorizationToken = authorizationToken => {
    const { authorizationToken: currentAuthorizationToken, setUserAuthData } = this.props;
    if (currentAuthorizationToken === authorizationToken) return;
    setUserAuthData({ authorizationToken });
  };

  setBlockMVPDIncomplete = v => this.setState({ blockMVPDIncomplete: v });

  setCoordinates = coordinates => {
    this.setState({ coordinates });
  };

  setCurrentPage = newCurrentPage => {
    const { currentPage } = this.state;
    if (currentPage === newCurrentPage) return;
    if (!isValidPage(newCurrentPage)) return;
    this.setState({ currentPage: newCurrentPage });
  };

  setDisableScroll({ disableScroll, overlay, cb }) {
    const { breakpoint } = this.state;
    const { breakpointDisableScroll } = breakpoints[breakpoint];
    if (disableScroll && breakpointDisableScroll) {
      scrollEvents.scrollEvent.register('end', () => {
        this.disableScrollByClass({ disableScroll, overlay, cb, breakpointDisableScroll });
        scrollEvents.scrollEvent.remove('end');
      });
      animateScroll.scrollTo(-1, { duration: 125, smooth: true });
    } else {
      this.disableScrollByClass({ disableScroll, overlay, cb, breakpointDisableScroll });
    }
  }

  setHeaderPin = value => {
    const { isHeaderPinned } = this.state;
    if (isHeaderPinned !== value) {
      this.setState({ isHeaderPinned: value });
    }
  };

  setHomePage = newIsHomePage => {
    const { isHomePage } = this.state;
    if (isHomePage === newIsHomePage) return;
    this.setState({ isHomePage: newIsHomePage });
  };

  setIsAuthenticated = value => {
    const { setUserAuthData } = this.props;
    setUserAuthData({ isAuthenticated: value });
  };

  setIsPlayerLoaded = newIsPlayerLoaded => {
    const { isPlayerLoaded, isWatchPage } = this.state;
    if (isPlayerLoaded === newIsPlayerLoaded) return;
    const newState = { isPlayerLoaded: newIsPlayerLoaded };
    if (newIsPlayerLoaded && isWatchPage) {
      newState.vodPlayerWasLoaded = true;
    }
    this.setState(newState);
  };

  setListPage = newIsListPage => {
    const { isListPage } = this.state;
    if (isListPage === newIsListPage) return;
    this.setState({ isListPage: newIsListPage });
  };

  setLivePage = newIsLivePage => {
    const { isLivePage } = this.state;
    if (isLivePage === newIsLivePage) return;
    this.setState({ isLivePage: newIsLivePage });
  };

  setLoading = newIsPageLoading => {
    this.setState({ isPageLoading: newIsPageLoading });
  };

  setMVPDToAppState = mvpd => {
    const { setUserAuthData } = this.props;
    setUserAuthData({ mvpd });
  };

  setNavScheduleRendered = newIsNavScheduleRendered => {
    const { isNavScheduleRendered } = this.state;
    if (isNavScheduleRendered === newIsNavScheduleRendered) return;
    this.setState({ isNavScheduleRendered: newIsNavScheduleRendered });
  };

  setOverlay = (chosenOverlay, chosenValue, cb) => {
    const { breakpoint, overlay } = this.state;
    let toggleValue = chosenValue;
    let disableScroll = false;
    let sentOverlay = chosenOverlay;
    if (!_.isBoolean(toggleValue)) {
      toggleValue = chosenOverlay !== overlay;
    }
    if (chosenOverlay && chosenOverlay !== overlay && chosenValue === false) return;
    if (toggleValue) {
      disableScroll = OVERLAY_BREAKPOINTS[breakpoint].indexOf(chosenOverlay) >= 0;
    } else if (overlay === chosenOverlay) {
      sentOverlay = null;
    } else if (!chosenOverlay && !chosenValue) {
      sentOverlay = null;
    }
    this.setDisableScroll({ disableScroll, overlay: sentOverlay, cb });
  };

  setProvider = provider => {
    const { account, mvpdProviders } = this.props;
    const findProviderAndSet = (providerId, providers) => {
      const providerObject = findProvider(providers, account, providerId);
      return this.setState({ provider: providerObject });
    };

    const providerFetched = getProviderObjectFromList(mvpdProviders, provider);
    if (!mvpdProviders || !providerFetched) {
      const checkForProviders = setInterval(() => {
        const { mvpdProviders: newProviders } = this.props;
        if (!newProviders) return null;
        clearInterval(checkForProviders);
        return findProviderAndSet(provider, newProviders);
      }, 1000);
    } else {
      findProviderAndSet(provider, mvpdProviders);
    }
    return null;
  };

  setPreauthRefreshComplete = value => {
    this.setState({ preauthRefreshComplete: value });
  };

  setSmartBannerEnabled = isSmartBannerEnabled => {
    const { state } = this;
    if (state.isSmartBannerEnabled === isSmartBannerEnabled) return;
    this.setState({ isSmartBannerEnabled });
  };

  setWatchPage = newIsWatchPage => {
    const { isWatchPage } = this.state;
    if (isWatchPage === newIsWatchPage) return;
    this.setState({ isWatchPage: newIsWatchPage });
  };

  anonymousLogin = ({ deviceId }) => {
    const { deviceId: currentDeviceId, setUserAuthData, profile } = this.props;
    return helperAnonymousLogin(setUserAuthData, deviceId || currentDeviceId, profile);
  };

  pageViewEvent = (opts = {}) => {
    const {
      collection,
      footerType,
      isFreemium,
      pageName,
      pageTitle,
      pageType,
      panelExperimentData,
      selectedMenuItem,
      seriesType,
      useUtagGlobal,
      cb,
    } = opts;
    const { favorites, provider } = this.state;
    const { account, preauthorizedResources: networkEntitlementList } = this.props;
    const pageViewEvents = async () => {
      if (!isStaticRender())
        await callTealiumPageView({
          account,
          collection,
          domain: getDomain(),
          favorites,
          footerType,
          isFreemium,
          networkEntitlementList,
          pageName,
          pageTitle,
          pageType,
          panelExperimentData,
          provider,
          selectedMenuItem,
          seriesType,
          useUtagGlobal,
          cb,
        });
    };
    pageViewEvents();
  };

  toggleMvpdAuthOverlay = (value = true, options = {}, blockSuccessScreen = true) => {
    this.setState({
      mvpdAuthOverlayProps: options,
      renderMvpdAuthOverlay: value,
      blockSuccessScreen,
    });
  };

  disableScrollByClass({ disableScroll, overlay, cb, bodyOnly, fixedPosition }) {
    if (disableScroll) {
      addBodyClass(['noScroll', 'bodyNoScroll']);
      if (!bodyOnly) addHTMLClass(['noScroll']);
      if (fixedPosition) addHTMLClass(['fixedPosition']);
    } else {
      removeBodyClass(['noScroll', 'bodyNoScroll']);
      if (!bodyOnly) removeHTMLClass(['noScroll']);
      if (!fixedPosition) removeHTMLClass(['fixedPosition']);
    }

    if (!_.isUndefined(overlay)) {
      const newState = { overlay };

      this.setState(newState, () => {
        if (_.isFunction(cb)) cb();
      });
    }
  }

  renderAuthContainer = additionalAuthProps => {
    const {
      account,
      anonymousAccount,
      anonymousId,
      authorizationToken,
      deviceId,
      preauthorizedResources,
      profile,
    } = this.props;
    const {
      blackoutDefinitions,
      blockMVPDIncomplete,
      blockSuccessScreen,
      breakpoint,
      provider,
      mvpdSignInTrigger,
    } = this.state;

    const useMVPDLoginProfile = !getStoredAuthenticatedMVPD() && false;

    const authProps = {
      account,
      accessToken: authorizationToken,
      anonymousAccount,
      anonymousId,
      anonymousLogin: this.anonymousLogin,
      blackoutConfig: getBlackoutConfig(),
      blackoutDefinitions,
      blockMVPDIncomplete,
      blockSuccessScreen,
      'data-test': 'auth-container',
      deviceId,
      isMobile: isMobileBreakpoint(breakpoint),
      isTablet: isTabletBreakpoint(breakpoint),
      mvpdLoginProfile: useMVPDLoginProfile,
      onAuthCheckComplete: this.onAuthCheckComplete,
      openSignIn: this.openSignIn,
      openSignUp: this.openSignUp,
      preauthorizedResources,
      pageViewEvent: this.pageViewEvent,
      profile,
      profileToken: authorizationToken,
      provider,
      mvpdSignInTrigger,
      requiresAuth: true,
      setAuthorizationToken: this.setAuthorizationToken,
      setIsAuthenticated: this.setIsAuthenticated,
      setMVPDSignInTrigger: this.setMVPDSignInTrigger,
      setMVPDToAppState: this.setMVPDToAppState,
      setOverlay: this.setOverlay,
      setProvider: this.setProvider,
      setTriggerAuthCheck: this.setTriggerAuthCheck,
      ...additionalAuthProps,
    };
    return <AuthContainer {...authProps} />;
  };

  renderDefaultHelmetTags = () => {
    const {
      location: { pathname },
    } = this.props;
    const SsrMetaData = pathname.includes('find') ? null : (
      <meta
        data-n-head="ssr"
        data-hid="robots"
        name="robots"
        content="index, follow, max-image-preview:large, max-video-preview:-1"
      />
    );
    const { headerTags } = NetworkConfig;
    const data = {
      ...headerTags,
      viewport: 'width=device-width, initial-scale=1',
      ogType: 'website',
      tags: [
        <meta key="content-type" httpEquiv="Content-Type" content="text/html; charset=UTF-8" />,
        SsrMetaData,
      ],
    };
    return <Seo seo={data} />;
  };

  renderGlobalVideoPlayer(freemiumProps) {
    const { isFreemium } = freemiumProps;
    const {
      adblock,
      authCheckComplete,
      authSuccess,
      blackoutDefinitions,
      breakpoint,
      coordinates,
      isHomePage,
      isLivePage,
      openSignIn,
      openSignUp,
      provider,
      triggerAuthCheck,
    } = this.state;
    const {
      account,
      anonymousId,
      anonymousAccount,
      authorizationToken,
      deviceId,
      location,
      params,
    } = this.props;
    const profileId = _.get(account, 'profileId') || _.get(anonymousAccount, 'profileId');
    const props = {
      ...this.getExternalHelpers(),
      accessToken: authorizationToken,
      account,
      adblock,
      anonymousId,
      anonymousLogin: this.anonymousLogin,
      authCheckComplete,
      authSuccess,
      blackoutConfig: getBlackoutConfig(),
      blackoutDefinitions,
      breakpoint,
      coordinates,
      'data-test': 'home-video-global',
      deviceId,
      isFreemium,
      isHomePage,
      isLivePage,
      key: 'home-video-global',
      location,
      openSignIn,
      openSignUp,
      params,
      profileId,
      provider,
      renderAuthContainer: this.renderAuthContainer,
      setAuthorizationToken: this.setAuthorizationToken,
      setIsAuthenticated: this.setIsAuthenticated,
      setIsPlayerLoaded: this.setIsPlayerLoaded,
      setMVPDSignInTrigger: this.setMVPDSignInTrigger,
      setMVPDToAppState: this.setMVPDToAppState,
      setOverlay: this.setOverlay,
      setProvider: this.setProvider,
      triggerAuthCheck,
    };

    return <VideoPlayerGlobal {...props} />;
  }

  onSimplifiedSignUpClick = () => {
    this.setState({ useSimplified: true });
    addBodyClass(['noScroll']);
  };

  wrapLoaderOverlay = children => {
    const { renderLoader } = this.state;
    return (
      <div className={classNames(renderLoader && AppStyleModule.loaderWrap)}>
        <img
          className={AppStyleModule.loaderImg}
          src="/static/images/loader.png"
          alt="Loading..."
        />
        <div className={classNames(renderLoader && AppStyleModule.hiddenContent)}>{children}</div>
      </div>
    );
  };

  render() {
    const {
      account,
      anonymousAccount,
      anonymousId,
      authorizationToken,
      bookmarks,
      buythroughScenario,
      children,
      continueWatchingData,
      fetchMVPDProviders,
      freemiumModalVisibility,
      freemiumRedirectUrl,
      isAuthenticated,
      location,
      mvpdProviders,
      params,
      preauthorizedResources,
      profile,
      seriesData,
      setFreemiumModalVisibility,
      setPreauthorizedResources,
      subscriptionPaused,
      topMVPDProviders,
      videoPanel,
    } = this.props;
    const {
      accountExpired,
      adblock,
      apiBreakpoint,
      blackoutDefinitions,
      breakpoint,
      campaignOverrides,
      coordinates,
      isHeader,
      isHeaderPinned,
      isHomePage,
      isListPage,
      isLivePage,
      isNationDigitalChannelEnabled,
      isNavScheduleRendered,
      isPageLoading,
      isPlayerLoaded,
      isVideoHero,
      isWatchPage,
      isSmartBannerEnabled,
      mvpdAuthOverlayProps,
      network,
      overlay,
      preauthRefreshComplete,
      provider,
      renderMvpdAuthOverlay,
      mvpdSignInTrigger,
      firstIdentifyCall,
      firstCollectionImpression,
      upcomingOverlayOpen: isUpcomingOverlayOpen,
      stickyBanner,
      useSimplified,
    } = this.state;
    const externalHelpers = this.getExternalHelpers();
    const blackoutConfig = getBlackoutConfig();
    const analyticsLoaded = !!_.get(window, 'analytics.init');
    const getChildrenWithProps = additionalProps =>
      React.Children.map(children, child =>
        React.cloneElement(child, {
          ...externalHelpers,
          account,
          accountExpired,
          adblock,
          analyticsLoaded,
          apiBreakpoint,
          authorizationToken,
          blackoutConfig,
          blackoutDefinitions,
          breakpoint,
          campaignOverrides,
          collectionImpressionCalled: this.collectionImpressionCalled,
          coordinates,
          disableScroll: this.disableScrollByClass,
          fetchMVPDProviders,
          firstCollectionImpression,
          firstIdentifyCall,
          isAuthenticated,
          isHeader,
          isHeaderPinned,
          isNavScheduleRendered,
          isPlayerLoaded,
          isUpcomingOverlayOpen,
          mvpdProviders,
          mvpdSignInTrigger,
          overlay,
          params,
          provider,
          setPreauthorizedResources,
          topMVPDProviders,
          upcomingOverlayOpen: this.upcomingOverlayOpen,
          ...additionalProps,
        }),
      );
    const { mainBackground } = breakpoints[breakpoint];
    const profileId = _.get(account, 'profileId');
    const anonymousProfileId = _.get(anonymousAccount, 'profileId');
    const accountEmail = _.get(account, 'email');
    const networks = [];
    const mvpd = _.get(provider, 'nameLowercase');
    const entitlements = _.isEmpty(preauthorizedResources)
      ? ''
      : preauthorizedResources.sort(sortEntitlements).join(',');
    const headerPadding = [style.defaultPadding];
    const homePath = helperGetHomeUrl();
    const currentPath = _.get(this.props, 'location.pathname');
    const isHome = homePath === currentPath;
    let background = isVideoHero && mainBackground ? null : mainBackground;

    if (isNavScheduleRendered) headerPadding.push(style.navPadding);
    if (!background && isVideoHero) background = style.blackBackground;
    _.each(network, name => networks.push({ name, logo: getNetworkLogoUrl(name, 50) }));
    const appStyle = classNames([
      style.app,
      getFontClassName(style),
      'ft-theme-provider',
      isStaticRender() && 'staticRender',
      AppStyleModule.appContainer,
      AppStyleModule.headerPadding,
    ]);
    const showFooterUpsell = false && isHome && FooterUpsellEnabled;
    const isLiveNationDigitalChannel =
      isLivePage && isNationDigitalChannelEnabled && currentPath?.includes('live-news');

    if (isWatchPage) this.setDisableScroll({ disableScroll: false });

    const isSeriesDetailPage = !_.isEmpty(params.showId);
    const isArticle = currentPath?.includes('/article/');
    const mainStyle = classNames([
      style.main,
      background,
      'ft-header-content',
      isLiveNationDigitalChannel && style.digitalChannelMenu,
      !isArticle ? AppStyleModule.overflowHidden : null,
    ]);
    const appWrapperStyle = classNames([isLiveNationDigitalChannel && style.appWrapper]);
    const useNationSlimFooter =
      isSeriesDetailPage &&
      !_.isEmpty(anonymousAccount) &&
      seriesAnonymousEnabled() &&
      !isNationEntitled();

    const rootId = isStaticRender() ? 'app-static' : 'app-root';
    let optimizelySeriesId = 'no-series';
    let isLicensed = false;
    if (isWatchPage) {
      isLicensed = isNationLicensed(videoPanel);
      optimizelySeriesId = videoPanel?.showCode;
    } else if (isSeriesDetailPage) {
      isLicensed = isNationLicensed(seriesData);
      optimizelySeriesId = seriesData?.showCode;
    }

    const components = (
      <FreemiumProvider
        isNation
        isHomePage={isHomePage}
        isNationLicensed={isLicensed}
        isWatchPage={isWatchPage}
        isSeriesDetailPage={isSeriesDetailPage}
        seriesId={optimizelySeriesId}
        isAuthenticated={isAuthenticated}
      >
        <FreemiumContext.Consumer>
          {freemiumProps => (
            <div id="live-page-overflow">
              <div className={appStyle} id={rootId}>
                <div className={classNames(headerPadding)} />
                {this.renderDefaultHelmetTags()}
                {getFontHelmetTag()}
                <WindowResizeListener
                  DEBOUNCE_TIME={DEBOUNCE_TIME}
                  onResize={this.onWindowResize}
                />
                <Segment
                  anonymousAccount={anonymousAccount}
                  account={account}
                  anonymousId={anonymousId}
                  entitlements={entitlements}
                  firstIdentifyCall={firstIdentifyCall}
                  firstSegmentIdentifyCalled={this.firstSegmentIdentifyCalled}
                  loggedInAccountEmail={accountEmail}
                  loggedInAccountProfileId={profileId}
                  loggedInAnonymousProfileId={anonymousProfileId}
                  mvpd={mvpd}
                  preauthorizedResources={preauthorizedResources}
                />
                {renderMvpdAuthOverlay && this.renderAuthContainer(mvpdAuthOverlayProps)}
                <Header
                  account={account}
                  accessToken={authorizationToken}
                  apiBreakpoint={apiBreakpoint}
                  breakpoint={breakpoint}
                  buythroughScenario={buythroughScenario}
                  campaignOverrides={campaignOverrides}
                  coordinates={coordinates}
                  isAuthenticated={isAuthenticated}
                  isFreemium={freemiumProps.isFreemium}
                  isHeader={isHeader}
                  isHeaderPinned={isHeaderPinned}
                  isHomePage={isHomePage}
                  isListPage={isListPage}
                  isLivePage={isLivePage}
                  isNavScheduleRendered={isNavScheduleRendered}
                  isPlayerLoaded={isPlayerLoaded}
                  isSeriesDetailPage={isSeriesDetailPage}
                  isVideoPage={isWatchPage || isLivePage}
                  isWatchPage={isWatchPage}
                  isSmartBannerEnabled={isSmartBannerEnabled}
                  key="header"
                  location={location}
                  mvpdProviders={mvpdProviders}
                  onSimplifiedSignUpClick={this.onSimplifiedSignUpClick}
                  overlay={overlay}
                  params={params}
                  preauthRefreshComplete={preauthRefreshComplete}
                  profile={profile}
                  provider={provider}
                  setMVPDSignInTrigger={this.setMVPDSignInTrigger}
                  setCoordinates={this.setCoordinates}
                  setAuthorizationToken={this.setAuthorizationToken}
                  setHeaderPin={this.setHeaderPin}
                  setNavScheduleRendered={this.setNavScheduleRendered}
                  setPreauthRefreshComplete={this.setPreauthRefreshComplete}
                  setProvider={this.setProvider}
                  setSmartBannerEnabled={this.setSmartBannerEnabled}
                  showAppDownloadPrompt={appDownloadPromptEnabled()}
                  subscriptionPaused={subscriptionPaused}
                  firstCollectionImpression={firstCollectionImpression}
                  collectionImpressionCalled={this.collectionImpressionCalled}
                  upcomingOverlayOpen={this.upcomingOverlayOpen}
                  useSimplified={useSimplified}
                  {...externalHelpers}
                />
                <div className={appWrapperStyle}>
                  {this.renderGlobalVideoPlayer(freemiumProps)}
                  <main role="main" className={mainStyle}>
                    {getChildrenWithProps(freemiumProps)}
                    <ContinueWatchingCTA
                      continueWatchingData={continueWatchingData}
                      latestBookmark={bookmarks?.list?.[0]}
                      onClose={clearContinueWatchingCTA}
                    />
                  </main>
                </div>
                {!isPageLoading && showFooterUpsell && (
                  <FooterUpsell
                    accessToken={authorizationToken}
                    breakpoint={breakpoint}
                    isPageLoading={isPageLoading}
                    {...externalHelpers}
                  />
                )}
                <Footer
                  showFooterUpsell={showFooterUpsell}
                  accessToken={authorizationToken}
                  breakpoint={breakpoint}
                  apiBreakpoint={apiBreakpoint}
                  isPageLoading={isPageLoading}
                  useNationSlimFooter={useNationSlimFooter}
                  {...externalHelpers}
                />
                <StickyBanner data={stickyBanner} />
                <BlackoutDefinitionFetcher
                  onComponentUpdate={this.onBlackoutDefinitionFetcherUpdate}
                />
                <CanIAutoplay />
                {freemiumProps.isFreemium && freemiumModalVisibility && (
                  <FreemiumModalContainer
                    threshold={freemiumProps.freemiumThreshold}
                    redirectUrl={freemiumRedirectUrl}
                    onClose={() => setFreemiumModalVisibility({ visibility: false })}
                  />
                )}
              </div>
            </div>
          )}
        </FreemiumContext.Consumer>
      </FreemiumProvider>
    );

    return wrapComponentsWithThemeProvider(this.wrapLoaderOverlay(components));
  }
}

App.defaultProps = {
  account: null,
  anonymousAccount: null,
  anonymousId: null,
  authorizationToken: null,
  buythroughScenario: null,
  children: null,
  deviceId: null,
  fetchMVPDProviders: noop,
  fetchUserSubscriptionStatus: noop,
  freemiumModalVisibility: false,
  freemiumRedirectUrl: null,
  initFennec: noop,
  isAuthenticated: false,
  mvpd: null,
  mvpdProviders: null,
  params: {},
  preauthorizedResources: [],
  profile: null,
  recommendationId: null,
  routes: [],
  segmentDeviceId: null,
  seriesData: null,
  stickyBanner: null,
  subscriptionPaused: false,
  topMVPDProviders: [],
  videoPanel: null,
};

App.propTypes = {
  account: PropTypes.shape({}),
  anonymousAccount: PropTypes.shape({}),
  anonymousId: PropTypes.string,
  authorizationToken: PropTypes.string,
  bookmarks: PropTypes.shape({}),
  buythroughScenario: PropTypes.string,
  children: PropTypes.node,
  clearContinueWatchingCTA: PropTypes.func,
  clearSeriesDetail: PropTypes.func,
  continueWatchingData: PropTypes.shape({}),
  deviceId: PropTypes.string,
  fetchContinueWatchingAction: PropTypes.func,
  fetchCurrentActivePlans: PropTypes.func,
  fetchMVPDProviders: PropTypes.func,
  fetchUserSubscriptionStatus: PropTypes.func,
  freemiumModalVisibility: PropTypes.bool,
  freemiumRedirectUrl: PropTypes.string,
  initFennec: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  location: PropTypes.shape({}).isRequired,
  mvpd: PropTypes.shape({}),
  mvpdProviders: PropTypes.arrayOf(PropTypes.shape({})),
  params: PropTypes.shape({}),
  preauthorizedResources: PropTypes.arrayOf(PropTypes.string),
  profile: PropTypes.shape({}),
  profileFavorites: PropTypes.shape({}),
  profileBookmarks: PropTypes.shape({}),
  recommendationId: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.shape({})),
  segmentDeviceId: PropTypes.string,
  seriesData: PropTypes.shape({}),
  setFreemiumModalVisibility: PropTypes.func.isRequired,
  setPreauthorizedResources: PropTypes.func.isRequired,
  setUserAuthData: PropTypes.func.isRequired,
  showMobileRoadblock: PropTypes.bool,
  stickyBanner: PropTypes.arrayOf(PropTypes.shape({})),
  subscriptionPaused: PropTypes.bool,
  topMVPDProviders: PropTypes.arrayOf(PropTypes.shape({})),
  videoPanel: PropTypes.shape({}),
};

const mapStateToProps = state => {
  const {
    account,
    activePlans,
    anonymousAccount,
    anonymousId,
    authorizationToken,
    buythroughScenario,
    continueWatchingData,
    deviceId,
    freemiumModalVisibility,
    freemiumRedirectUrl,
    isAuthenticated,
    mvpd,
    mvpdProviders,
    preauthorizedResources,
    profile,
    profileBookmarks,
    profileFavorites,
    recommendationId,
    segmentDeviceId,
    showMobileRoadblock,
    subscriptionPaused,
    topMVPDProviders,
  } = state.app;
  const stickyBanner = getStickBannerData(state);
  const seriesData = makeSelectSeriesDetailSeriesData(state);
  const videoPanel = makeSelectGlobalVideoPanelVideo(state);
  return {
    account,
    activePlans,
    anonymousAccount,
    anonymousId,
    authorizationToken,
    bookmarks: state.collection.bookmarks,
    buythroughScenario,
    continueWatchingData,
    deviceId,
    freemiumModalVisibility,
    freemiumRedirectUrl,
    isAuthenticated,
    mvpd,
    mvpdProviders,
    preauthorizedResources,
    profile,
    profileBookmarks,
    profileFavorites,
    recommendationId,
    segmentDeviceId,
    seriesData,
    showMobileRoadblock,
    stickyBanner,
    subscriptionPaused,
    topMVPDProviders,
    videoPanel,
  };
};

const mapDispatchToProps = {
  clearContinueWatchingCTA,
  clearSeriesDetail,
  fetchCurrentActivePlans,
  fetchContinueWatchingAction,
  fetchMVPDProviders: fetchMVPDProvidersAction,
  fetchUserSubscriptionStatus: fetchUserSubscriptionStatusAction,
  setFreemiumModalVisibility: setFreemiumModalVisibilityAction,
  setPreauthorizedResources: setPreauthorizedResourcesAction,
  setRecommendationId: setRecommendationIdAction,
  setUserAuthData,
};
const WrappedApp = withErrorBoundary(App);
WrappedApp.fetchData = ({ store, accessToken }) => Footer.fetchData({ store, accessToken });

export default connect(mapStateToProps, mapDispatchToProps)(WrappedApp);
